export default __webpack_public_path__ + "static/media/add.6ea990a4.svg";